import { wowsEntities } from '@wg/wows-entities';
import { TooltipProvider } from '@wg/wows-react-uikit';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import i18n from './i18n';
import router from '~/router/router';
import preloaded from '~/preloaded';
import store from '~/store';
import { loadFeatures } from '~/store/shipFeatures';

import 'swiper/scss';
import 'swiper/scss/free-mode';
import '@wg/wows-css-uikit/index.css';
import '@wg/wows-entities/index.css';
import './assets/styles/global.scss';

wowsEntities
    .init({
        vortexBaseUrl: `https://${preloaded.urls.vortex}`,
        languageCode: preloaded.settings.languageCode,
    })
    .then(() => {
        window.dockyard.settings.version = String(wowsEntities.settings.gameVersion);
        store.dispatch(loadFeatures());
    });

export default function Root() {
    return (
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <TooltipProvider>
                    <RouterProvider router={router} />
                </TooltipProvider>
            </I18nextProvider>
        </Provider>
    );
}
